/** Gets a normalized one-line version of the comment text for compact previews and labels. */
export function getCommentSnippet(bodyHtml: string): string {
  const text = new DOMParser().parseFromString(bodyHtml, 'text/html').documentElement.textContent
  const singleLine = text?.replace(/\s+/g, ' ').trim() ?? ''

  // Even though we truncate with CSS, we still need to truncate the string here for accessibility because screen readers
  // ignore overflow/truncation (and so the string can be used in `aria-label` attributes)
  return singleLine.length > 150 ? `${singleLine.slice(0, 150)}…` : singleLine
}
